"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/** Returns viewport and keyboard to the top of the page once more than one
 *  page is retained — on a single page there is nothing to come back from. */
export default function BackToTop(t0) {
  const $ = _c(6);
  const {
    enabled,
    label
  } = t0;
  const [shown, setShown] = useState(false);
  let t1;
  let t2;
  if ($[0] !== enabled) {
    t1 = () => {
      if (!enabled) {
        return;
      }
      const onScroll = () => setShown(window.scrollY > window.innerHeight * 1.5);
      onScroll();
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", onScroll);
    };
    t2 = [enabled];
    $[0] = enabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!enabled || !shown) {
    return null;
  }
  const go = _temp;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowUp aria-hidden={true} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== label) {
    t4 = <button type="button" className="v2-cd-top v2-focus" onClick={go} aria-label={label} title={label}>{t3}</button>;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp() {
  window.scrollTo({
    top: 0,
    behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
  });
  document.getElementById("v2-main")?.focus({
    preventScroll: true
  });
}